import { Skeleton, Stack } from "@mui/material"
import { colors } from "../../services/config/colors"
import Title from "./Title"
import { CSSProperties } from "react"
import { useTranslation } from "react-i18next"
import { formatNumber } from "../../services/utils/utils"

const PointsBadge = ({
  points,
  loading,
  style,
}: {
  points: number
  loading: boolean
  style?: CSSProperties
}) => {
  const { t } = useTranslation()

  return loading ? (
    <Skeleton
      variant="rectangular"
      style={{ width: 50, height: 22, borderRadius: 3.6, ...style }}
    />
  ) : (
    <Stack
      justifyContent="center"
      style={{
        width: "auto",
        height: 22,
        paddingInline: 5.5,
        borderRadius: 3.6,
        border: "1.5px solid " + colors.disabled,
        backgroundColor: colors.background,
        ...style,
      }}
    >
      <Title fontSize={14} color={colors.primary}>
        {formatNumber(points)} {t("pt")}
      </Title>
    </Stack>
  )
}

export default PointsBadge
